// 状態
const state = {
  preheatIng: "発売待ち",
  purchaseIng: "購入中",
  process: "助力中",
  over: "終了",
  finish: "完了",
  noData: "データなし",
};
  
  // 購入エリアと個人の購入履歴ページの上部のサブヘッダー
  const subheader = {
    pricePromise: "価格保証、絶対に発行価格を下回りません",
    vipPrice: "VIPリベート、価格優遇",
    protection: "独自の法定通貨本位で価格保証",
    pricePromiseVal: "[*]日価格保証、絶対に発行価格を下回りません",
    rewards: "[*]%利益、価格保証を約束",
    vipDis: "VIP割引、手に入れたら確実に利益が出る",
    zlz: "助力中",
  };
  
  // 購入エリア
  const purchase = {
    periods: "第[*]期",
    timesSheaves: "第[*]ラウンド",
    supportPic: "[*]日価格保証、絶対に発行価格を下回りません",
    earnings: "[*]%利益、価格保証を約束",
    vipDiscount: "VIP割引、手に入れたら確実に利益が出る",
    limit: "このラウンドの限度額",
    timeLimit: "特売価格",
    schedule: "現在の進捗状況",
    finishHalf: "[*]%完了",
    subscriptionNum: "購入数量",
    vipText: "（VIP[*]）で購入（[**] [***] [****]割引）優待", //（VIP6）で購入（2000COINS 5割引）優待
    supportType: "価格保証方式：保証期間中、BiKingはセカンダリマーケットに最低価格で注文を出し、ユーザーは保証期間中に売却するかどうかを選択できます。保証期間が終了すると、関連する最低価格の注文はキャンセルされます。",
    beAbouttoAlipay: "もうすぐ開始",
    atOnceAlipay: "今すぐ購入",
    atOnceAlipayNew: "今すぐ助力",
    atOnceAlipayed: "購入済みです、次のラウンドに注目してください",
    atOnceAlipayedOver: "購入済みです、再度購入できません",
    atOnceAlipayedNew: "助力済みです、次のラウンドに注目してください",
    atOnceAlipayedNewOver: "助力済みです、再度参加できません",
    website: "ウェブサイト",
    whitePaper: "ホワイトペーパー",
    foreshow: "購入予告",
    startToUp: "購入を開始",
    startToUpNew: "助力を開始",
    distanceStartToUp: "開始まで",
    num: "現在は累計（[*]）人が購入しました（[**] BAT）",
    bannerText: "[*]が[*]限度額を購入",
    bannerTextNew: "[*]が[*]限度額を助力",
    nextProject: "利用可能な限度額が尽きました。次のプロジェクトに注目してください",
    timesText: "今回の限度額全額が完売しました。次回は[*]月[*]日[***]：[****]：[*****]に正確に開始します",
    times: "[*]日[*]時[***]分[****]秒",
    viewDetail: "詳細を確認",
    completePawd: "口座の取引パスワード設定を完了する",
    sureCoins: "保有コインが[*] [**]（最低購入量）より大きいことを確認してください",
    sureBalance: "口座の残高が[*]より大きいことを確認してください",
    set: "設定する",
    available: "購入可能な限度額",
    holding: "口座の保有ポジション",
    startSoon: "間もなく購入開始",
    startSoonNew: "間もなく助力開始",
    projectSupp: "プロジェクト限度額",
    projectSuppNew: "助力上限",
    successBuy: "購入成功",
    successBuyNew: "助力成功",
    projectLimit: "プロジェクト開始までの残り時間",
    subscription: "購入済み",
    subscriptionNew: "助力済み",
    projectGoal: "プロジェクトの総購入額",
    projectGoalNew: "プロジェクトの助力額",
    goalFunds: "現在の購入済み金額",
    goalFundsNew: "目標達成の実際の助力額",

  };
  
  // 購入条件
  const purchaseCondition = {
    q: " かつ ",
    h: " または ",
    cztj: "入金数量を確保する",
    wqyh: "関連する過去のイベントに参加していないユーザーに限る",
    vipdj: "VIP[*]以上のVIPレベルのユーザーに限る",
    condition: "購入条件",
    conditionNew: "助力条件",
    nameverify1: "中国本土のKYC認証を完了する",
    nameverify2: "中国本土以外のKYC認証を完了する",
    nameverify3: "BiKing KYC認証を完了する",
    login: "ログインしてください",
    maxBuyin: "最大購入額",
    verify: "KYC認証に移動",
    affirm: "保有量が[*]より大きいことを確認してください",
    myPosition: "私の保有ポジション",
    AmountOfAscension: "購入限度額",
    AmountOfAscensionNew: "助力限度額",
    AmountOfAscensionText: "第一ラウンド開始前7日の[*]の平均保有ポジション量が大きいほど、購入限度額が大きくなります",
    AmountOfAscensionTime: "私の前7日の[*]の平均保有ポジション量",
    discount: "割引購入",
    vip_discount: "割引サポート",
    discountText: "VIPレベルが高いほど、購入価格が低くなります",
    upgrade: "アップグレードに移動",
    vipUpgrade: "私のVIP",
    zled: "助力限度額",
    wdzl: "私の助力",
    zlxm: "助力プロジェクト",
    mlzl: "各ラウンドの助力",
    zlmx: "助力の詳細",
    ccff: "初回発行",
    qgmx: "購入の詳細",
  
    fjtj: "追加条件",
    guoji: "国籍",
    noJoin: "参加不可",
    wancheng: "完了",
    pinggu: "「仮想通貨投資リスク評価書」",
    cyhd: "イベントに参加",
  };
  
  // 過去のプロジェクト
  const historyProject = {
    rushLimit: "購入限度額",
    averagePic: "平均価格",
    averageNum: "購入人数",
  };
  
  // 支払い
  const alipay = {
    alipaynum: "購入数量",
    alipaynumNew: "助力限度額",
    ShouldPay: "お支払い額",
    VipDiscounts: "VIP割引",
    VipWin: "Win会員割引",
    willOpen: "もうすぐオープン",
    actualPayment: "実際の支払額",
    actualPaymentNew: "今ラウンドの助力",
    importPassword: "取引パスワードを入力してください",
    forGetPassword: "取引パスワードを忘れましたか？",
    promptlyAlipay: "今すぐ支払う",
    purchaseSuccess: "おめでとうございます、購入成功です",
    purchaseSuccessNew: "おめでとうございます、助力成功です",
    purchaseError: "申し訳ありません、購入が失敗しました。ページを更新して再試行してください",
  };
// プロジェクト詳細
const projectDetails = {
  text: "[*][**]を超えるポジションを保有していることを確認する",
    timelimitPic: "限時価格",
    subscriptionLimit: "購入限度額",
    subscriptionLimitNew: "助力限度額",
    preheat: "発売待ち",
    supportAbort: "価格保証終了",
    unlockAbort: "発行時間",
    projectIntroduction: "プロジェクト紹介",
    projectRole: "イベントルール",
    rule: "購入ルール",
    ruleNew: "助力ルール",
  
  };
  // 購入終了
  const purchaseOver = {
    haveSubscribed: "購入済み限度額",
    schedule: "現在の進捗",
    Stime: "購入開始時間",
    StimeNew: "助力開始時間",
    Etime: "購入終了時間",
    EtimeNew: "助力終了時間",
    successText: "このプロジェクトの調達限度額は [*] BAT で、実際の調達額が目標額に達成され、調達成功です！",
    success: "成功",
  };
  // 私の購入
  const myPurchase = {
    endUnlock: "最後の購入が終了し、ロックが解除されました",
    endUnlock2: "最後の購入が終了し、発行が行われました",
    LText: "保証期間内の毎日のロック解除",
    WText: "保証期間外の毎日のロック解除",
    unlockend: "ロック解除済み",
    record: "購入詳細",
    myPurchaseName: "私が参加したプロジェクト",
  };
  
  // mHeader
  const mHeader = {
    sy: "ホーム",
    ksjy: "クイック取引",
    zyjy: "プロトレード",
    c2c: "C2C取引",
    otc: "OTC取引",
    zczx: "資産センター",
    xwgg: "ニュースとアナウンスメント",
    xwgg1: "アナウンスメント",
    lc: "BiKing Earn",
    gxlc: "高金利ファイナンス",
    dxjh: "FansUp!",
    fbjy: "コインを購入",
    dl: "ログイン",
    zc: "登録",
    jtzw: "簡体字中国語",
    ftzw: "繁体字中国語",
    english: "English",
    kr: "한국어",
    qgms: "瞬時購入",
    xsjy: "潜ポテンシャル取引",
    // 残りの国際化
    zczgz: "総資産評価額",
    yhzx: "マイページ",
    wdgl: "注文管理",
    tc: "アカウントをログアウト",
    dltq: "低流通エリア",
    sdgm: "スピード購入",
  
    // アプリのダウンロード
    appdown: "アプリのダウンロード",
    appdown1: "ダウンロード",
    biking: "BiKingアプリ",
    gfqb: "公式ウォレット",
    xzbyapp: "BiKing アプリをダウンロード",
    xzbyapp2: "BiKing アプリをダウンロード",
    smewm: "QRコードをスキャン",
    xzhyqb: "HyperPayウォレットをダウンロード",
    xzhyqb2: "HyperPayウォレットをダウンロード",
    bbjy: "現物取引",
    hyjy: "無期限先物", //"先物取引",
    eftjy: "ETF取引",
    byb: "コインを稼ぐ",
    newPos: "HBTマイニングプール",
    HyperPay: "HyperPayでコインを稼ぐ",
    hqlc: "POSマイニング",
    newlc: "コインを稼ぐ",
  
    // 新しいヘッダー
    dd: "注文",
    zichan: "資産",
    xxzx: "メッセージセンター",
    zhyaq: "口座とセキュリティ",
    sfyz: "本人確認",
    wdvip: "マイVIP",
    apigl: "API管理",
    hdzx: "イベントセンター",
    wdhb: "私のラッキーマネー",
    flzx: "特典センター",
    bitloan: "コインレンディング",
    ggjy: "レバレッジ取引",
    hyxy: "アカデミー",
    flhd: "特典イベント",
    bitWin: "BiKinｇファイナンス",
  };
  // 進捗状況
  const mProgress = {
    dqjd: "現在の進捗",
    yjs: "ロック解除済み",
  };
  
  // res
  const res = {
    // 購入エラーメッセージ
      seckill_project_000: "システムエラー",
      seckill_project_001: "利用可能なプロジェクトがありません",
      seckill_project_002: "プロジェクト情報が存在しません",
      // ユーザー情報エラーメッセージ
      seckill_userInfo_001: "ユーザーが存在しません",
      // i18nエラーメッセージ
      i18n_no_table_001: "システムが混み合っております",
      // 購入履歴
      seckill_record_1: "支払いが失敗しました",
      // 7日間ポジション保有ルール
      seckill_7days_1: "現在のプロジェクトにおいて、ポジション保有ルールが見つかりませんでした",
      // ウォレット関連
      seckill_wallet_1: "システムが混み合っております",
      seckill_wallet_2: "ウォレット残高が不足しています",
      seckill_wallet_3: "支払いが失敗しました",
      // プロジェクト統計
      seckill_record_count_1: "データエラー",
      seckill_record_count_2: "支払いが失敗しました",
      seckill_record_count_3: "支払いが失敗しました",
      // プロジェクトラウンド
      seckill_rounds_1: "システムが混み合っております",
      seckill_rounds_2: "現在のプロジェクトにおいて、購入中のラウンドが見つかりませんでした",
      seckill_rounds_3: "現在のプロジェクトにおいて、ラウンド情報が見つかりませんでした",
      seckill_rounds_4: "システムが混み合っております",
      seckill_rounds_5: "現在のプロジェクトにおいて、指定されたラウンド情報が見つかりませんでした",
      // プロジェクト情報
      seckill_pro_1: "プロジェクト情報が見つかりませんでした",
      seckill_pro_2: "購入限度額が最小購入数量を下回っています",
      seckill_pro_4: "システムが混み合っております",
      seckill_pro_5: "プロジェクトが非公開状態です",
      // 支払い
      seckill_pay_1: "システムが混み合っております",
      seckill_pay_2: "システムが混み合っております",
      seckill_pay_3: "プロジェクト情報が見つかりませんでした",
      seckill_pay_4: "購入限度額が最小購入数量を下回っています",
      seckill_pay_5: "購入限度額が現在のラウンドの残り限度額を超えています",
      seckill_pay_6: "購入限度額がありません",
      seckill_pay_7: "購入限度額が購入額を超えています",
      seckill_pay_8: "システムが混み合っております",
      seckill_pay_9: "取引パスワードが間違っています",
      seckill_pay_10: "支払いが失敗しました。もう一度購入してください",
      seckill_pay_11: "支払いが失敗しました。もう一度購入してください",
      seckill_pay_12: "ユーザー情報エラー",
      seckill_pay_13: "支払いが失敗しました",
      seckill_pay_14: "取引パスワードが間違っています",
      seckill_pay_15: "システムが混み合っております",
      seckill_pay_16: "すでに購入が完了しました",
      seckill_pay_17: "申し訳ありません、現在購入者が混み合っております。もう一度お試しください",
      seckill_pay_18: "このラウンドは既に購入が完了しました",
      seckill_pay_19: "このラウンドは既に完売しました",
      seckill_pay_20: "まずログインしてください",
      seckill_pay_21: "本人確認を完了してください",
      seckill_pay_22: "このプロジェクトは、中国本土のKYCユーザーのみが購入可能です",
      seckill_pay_23: "このプロジェクトは、中国本土以外のKYCユーザーのみが購入可能です",
      seckill_pay_24: "取引パスワードの試行回数が制限を超えました。しばらくしてから再試行してください",
      seckill_hold_1: "[*]の保有量が条件を満たしていません。購入後に参加してください",
      // アンケート調査
      seckill_survey_submited: "このアンケートには既に回答済みです",
      seckill_survey_error: "アンケート情報の処理にエラーが発生しました",
      seckill_survey_info: "現在のプロジェクトにおいて、該当するアンケート情報が見つかりませんでした",
    
  };
  const addContent = {
    hdjshy:'イベントは終了しました',
    qgsj: "購入時間",
    qgsjNew: "助力時間",
    gz: "ルール",
    zdjg: "最安値",
    sq: "閉じる",
    qgms: "瞬時購入",
    rgxm: "参加プロジェクト",
    bled: "本ラウンドの限度額",
    dqjd: "現在の進捗",
    yjs: "ロック解除済み",
    yff: "発行済み",
    qbcc: "保有ポジション",
    cg: "超える",
    jxmks: "プロジェクト開始まで",
    ycgrg: "既に購入成功しました",
    cgrg: "購入成功",
    xmed: "プロジェクト限度額",
    cxmck: "プロジェクトの資金調達",
    ckmb: "実際の調達が目標に達成",
    ck: "資金調達",
    ckxq: "詳細を確認する",
    kqed: "購入可能な限度額",
    zhcc: "口座の保有ポジション",
    jjks: "購入がまもなく開始",
    mmsz: "取引パスワードの設定を完了",
    qsz: "設定に進む",
    qbye: "口座内の[*]残高が[**]以上あることを確認",
    zjcz: "[*] [**] を超えるポジション保有量が必要です",
    jgdb: "価格保証、絶対に発行価格を下回りません",
    jgyh: "VIPリベート、価格が優遇されます",
    bwbj: "独自の法定通貨本位の価格保証",
    bj: "[*]日間の価格保証、絶対に発行価格を下回りません",
    sybj: "[*]%の収益、価格保証をお約束します",
    zk: "VIP割引、手に入れたら確実に利益が出る",
    r: "人",
    lsxm: "過去のプロジェクト",
    bpf: "コミュニティの助力、多くの福利待つ",
    syybz: "低いエントリーバリュー、特典が盛り沢山",
    hg: "VIP会員になり、さらに多くの特典を楽しめる",
    zgkx: "最大限度[*] [**] 削減できます",
    vip_zgkx: "VIPランクが高いほど、割引率が高くなります。最大のVIP6は[*] [**] の割引を受けられます",
    vip_zgkxNew: "VIPランクが高いほど、助力総額の割引率が高くなります。最大のVIP6は[*] [**] の割引を受けられます",
    blsysj: "本ラウンドの残り時間",
    blqbqw: "本ラウンドはすべて完売しました",
    xyl: "次のラウンド",
    zskq: "定刻に開始",
    bljshs: "本ラウンドの購入はもうすぐ終了",
    zqyc: "各ラウンドで1回しか購入できません。次のラウンドで再試行してください",
    zxkf: "本イベントに参加する権限がありません。詳しくはカスタマーサービスにお問い合わせください",
    zqycNew: "各ラウンドで1回しか助力できません。次のラウンドで再試行してください",
    wed: "このプロジェクトの利用可能な購入枠はゼロです。次のプロジェクトを注目してください",
    wedNew: "このプロジェクトの利用可能な助力枠内はゼロです。次のプロジェクトを注目してください",
    zsqg: "最小購入限度は[*] [**] です。ポジションを追加する必要があります",
    srmm: "取引パスワードを入力してください",
    smrz: "KYC本人確認を完了してください",
    qszjymm: "まず取引パスワードを設定してください",
    wenjuandiaocha: "本イベントに参加する前にアンケートを完了する必要があります",
    scqgms: "BiKingファンフェスティバル",
    hxyh: "BiKingコミュニティを助力して、特典を楽しむ",
    zsqged: "最小購入限度額は[*] [**] です",
    zsqgedNew: "最小助力限度額は[*] [**] です",
    wmtj: "[**]の保有量が条件を満たしていません。購入後に参加してください",
    qjchqg: "ポジションを追加する必要があります。購入してから再試行してください",
    qjchqgNew: "ポジションを追加してから助力を再試行してください",
    rgjg: "購入価格",
    qqg: "購入割引",
    wdqgjl: "私の参加履歴",
    ckxmxq: "プロジェクトの詳細を確認する",
    t: "日",
    yr: "[*]月[**]日",
    yrz: "第[*]ラウンド発売待ち",
    qgz: "第[*]ラウンド購入中",
    djlyjs: "第[*]ラウンドは終了しました",
    dj: "VIPランク",
    xszk: "割引比率",
    jgzked: "参加割引限度額",
    zked: "割引限度額",
    edw: "限度額外は通常価格で支払う",
    qbcczd: "保持ポジションが1000CWT（最低購入量）を上回るように確認してください",
    qrrjcc: "過去7日間の平均ポジション保有量",
    jlblks: "本ラウンドの開始まで",
    jlbljs: "本ラウンドの終了まで",
    zgkqed: "最大購入枠内は",
    zgkzf: "最大支払い可能額は",
    cggmsl: "入力した購入数量が購入制限を超えています",
    bzzfzxgm: "現在の保有ポジションは最小購入量をしはらいできません",
    bqzdqg: "購入の最小限度額は [*] [**] です",
    zlzcLower: "最小限度額は[*]、最大限度額は[**]です。イベント終了後、助力で得たコインは5営業日以内に口座に送金されます。",
    zgqged: "最大枠内は [*] [**] です",
    yzbz: "優れたコイン種類の限定ファン割引",
    xszkj: "限定割引価格",
    zlbxsq: "主要なコインを限時購入",
    wks: "開始待ち",
    jxz: "進行中",
    qgsl: "購入数量",
    wcydxm: "参加したプロジェクト",
    bjq: "見積り期",
    hgq: "買い戻し期",
    qzk: "購入で割引",
    qxzl: "先に助力して、コインを獲得",
    ds: "助力上限",
    dhbl: "交換比率",
    jicj: "基本価格",
    jiagzd: "最終価格は購入開始の3時間前に確定します",
    zdyh: "最大割引",
  };
  
  const hyy = {
    bkt: "開通しません",
    wqdkt: "開通します",
    kt12: "1. 参加する前に、仮想通貨の先物取引の基本的な知識や関連するリスク、およびデリバティブ取引に関連するすべての業務ルールなどを十分に理解してください。",
    kt13: "2. このリスク警告書で挙げたリスク事項は一部です。仮想通貨のデリバティブ取引に関連するすべてのリスク要因を十分に理解し、把握する必要があります。",
    kt14: "3. 投資者に対して、リスク耐性など、自身の実際の状況に基づいて、慎重にこの契約取引に参加するかどうかを判断するようお願いいたします。",
    kt0: "親愛なるユーザー様：",
    kt1: "先物口座と先物取引権限を開通していないため、以下の内容をよく読んでから開通を決定してください：",
    kt2: "一、先物市場で取引を行う際、市場価格の動向が不利で、あなたのポジション保証金が不足する場合、BiKing無期限先物はシステム規定に従って、あなたのポジションを強制的に清算し、清算の詳細を公開します。",
    kt3: "二、BiKing無期限先物の業務ルールを真剣に読み、先物のメカニズムと運用原則を理解し、市場のさまざまなリスクに対する認識を深めてください。",
    kt4: "四、BiKing無期限先物が接続されているのは先物取引システムであり、ユーザーのポジションの利益と損失は先物の市場動向に応じて変動します。大幅な損失が発生した場合、先物取引所のシステムにおけるロスカットが発生する可能性があります。ユーザー様は自身の取引行動を適切に行い、自己の損益を負うものとします。したがって、BiKingは推定または確定した保証責任を負いません。",
    kt5: "五、極端な市場状況では、保有している未決済先物を清算することが困難または不可能な場合があります。たとえば、あなたの利益が先物市場全体の効果的なレバレッジPnL内で最初にランクされ、対向取引先が保険基金がその清算損失をカバーするのに十分でない場合です。",
    kt6: "六、デジタル資産のデリバティブ取引は、一部の法律の適用範囲内での政策監視リスクに直面する可能性があり、取引の前には該当する地域の政策監視背景を理解した上で、慎重に判断する必要があります。関連する国や地域の法律、法規、政策の変更、先物取引所の取引ルールの変更、緊急措置の発表などにより、BiKingは事前に声明を発表し、保有している未決済契約が継続できない場合がありますが、保証金と利益の残高は引き続き交換されます。",
    kt7: "七、非プラットフォームのコントロール可能な原因（例：地震、洪水、火災などの不可抗力、またはコンピュータシステム、通信システムの障害など）により、注文が約定しないか、すべての注文が約定しない場合があります。そのため生じる損失は、ユーザーご自身が負担する可能性があります。",
    kt8: '八、"ヘッジ"取引は、投機取引と同様に、価格の変動に起因するリスクに直面します。',
    kta9: "九、本人確認を行っていない場合、またはGoogle認証を登録していない場合、またはアカウントを他人に貸し出している場合、先物保証金の安全性が損なわれる可能性があります",
    kta10: "三、極端な市場状況では、保有している未決済契約を清算することが困難または不可能な場合があります。たとえば、あなたの利益が契約市場全体の効果的なレバレッジPnL内で最初にランクされ、対向取引先が保険基金がその清算損失をカバーするのに十分でない場合です。",
    kt9: "私はよく内容を確認し、リスクを受け入れます",
    kt10: "先物口座と先物取引権限を開通する",
    zjhz: "資金振替",
    ljhz: "今すぐ振替",
    qx: "キャンセル",
    khz: "振替可能",
    qxz: "選択してください",
    bz: "通貨",
    c: "から",
    zz: "に",
    sl: "数量",
    qb: "全部",
    ktcg: "開設成功",
    ktsb: "開設失敗",
    hzcg: "振替成功",
    hzsb: "振替失敗",
    wyyd: "チェックボックスにチェックを入れてください",
    tc: "閉じる",
    warning1: "通貨を選択してください",
    warning2: "出金口座が空欄です",
    warning3: "入金口座が空欄です",
    warning4: "振替可能な数量を超えないように数字を入力してください",
    gb: "閉じる",
    openSuccess: "先物取引を開通しました",
    openSuccessTip: "資金を先物口座に振替してください",
    warning5: "最大4桁の小数を保持してください",
    not_get_nm: "申し訳ありません、泥コードイベントは終了しました。今回の振替で泥コードを受け取ることはできませんでした",
  }
  const trading = {
    gflj: '公式リンク',
    gw: '公式ウェブサイト',
    qkllq: 'ブロックエクスプローラー',
    scfxsj: '初回発行時間',
    fxzl: '発行総量',
    ltzl: '流通総量',
    jy: '取引',
    sj: '市場価格',
    tbxx: 'チャート情報',
    bzgk: '通貨概況',
    ddb: '注文表',
    zxcj: '最新約定',
  
    reload: "更新",
    socketError: "ネットワークエラー、",
    noData: "データなし",
    entrustorder: "板",
    prices: "価格",
    quantity: "数量",
    grandtotal: "累計",
    transamount: "取引額",
    time: "時間",
    available: "利用可能",
    limitorder: "指値",
    plancommission: "トリガー注文",
    currentcommission: "注文",
    historycommission: "過去の注文",
    completecommission: "成約注文",
    funds: '資金',
    hidetrading: "他の取引ペアを非表示",
    morecurrentcommission: "その他の現在の注文を表示",
    morehistorycommission: "その他の過去の注文を表示",
    moredocommission: "その他の成約注文を表示",
    realtimetrans: "リアルタイム取引",
    myassets: "私の資産",
    detail: "詳細",
    buyin: "購入",
    sellout: "売却",
    login: "ログイン",
    transfer: "振替",
    recharge: "入金",
    withdrawal: "コイン購入",
    quickpurchase: "法定通貨のクイック購入",
    default: "デフォルト",
    ordertime: "注文出し時間",
    tradingpair: "取引ペア",
    direction: "方向",
    types: "タイプ",
    commissionprice: "注文価格",
    commissionnumber: "注文数量",
    dealprice: "平均約定価格",
    dealnumber: "約定数量",
    triggerprice: "トリガー価格",
    cancelall: "全ての注文をキャンセル",
    averageprice: "平均価格",
    totalsum: "合計",
    fixedprice: "指値価格",
    marketprice: "市場価格",
    codeExpired: "QRコードが無効です",
    clickRefresh: "クリックして更新",
    QRsuccessfully: "QRコードをスキャン成功しました",
    loginInApp: "アプリ内でログインを確認してください",
    backtoQR: "QRコードログインに戻る",
    loginSuccess: "ログインが成功しました、BiKingへようこそ！",
    loadingText: "読み込み中...",
    searchPlaceholder: "検索",
    all: "すべて",
    currency: "通貨",
    price: "最新価格",
    market: "上げ幅ランキング",
    increase: "上げ幅",
    highestPrice: "最高値",
    minimumPrice: "最安値",
    turnover: "取引量",
    jydlb: "取引ペアリスト",
    bzjs: "通貨紹介",
    currencyTransaction: "現物取引",
    leveragedTransaction: "レバレッジ取引",
    warning:
      "リスク警告：Bitcoin Cashのフォークは非常に不確定です。フォーク先物コインの取引や投資には大きなリスクが伴います。特定のチェーンがマイナーサポートを受けない場合、存続しない可能性があり、関連するコインの価値はゼロになる可能性があります。BiKingはいかなるフォーク先物コインの価値について保証しません！",
    zb: "指標",
    date: "日付",
    UpAnddown: "上昇と下落",
    amplitude: "振幅",
    0: "分時",
    1: "1分",
    5: "5分",
    15: "15分",
    30: "30分",
    60: "1時間",
    240: "4時間",
    3600: "1日",
    10800: "1週間",
    dates: "期間：",
    password: "取引パスワード",
    errorPassword: "正しい取引パスワードを入力してください",
    worningPassword: "取引パスワードを入力してください",
    cancel: "キャンセル",
    sure: "確認",
    canBuy: "購入可能",
    canCell: "売却可能",
    withdraw: "出金",
    otc: "OTC、法定通貨での迅速な入出金",
    enterPrice: "価格を入力してください",
    sellingPrice: "売値",
    purchasePrice: "買値",
    salesVolume: "売却量",
    buyingVolume: "購入量",
    volume: "取引量",
    serviceCharge: "手数料",
    vip: "VIPにアップグレードして手数料割引を受ける",
    or: "または",
    register: "登録",
    totalPrice: "取引額はこの数字を上回ることができません",
    amountTip: "正しい数量を入力してください",
    amountTipError: "数量は",
 
    limitTrading: "指値取引",
    priceReminder: "価格リマインダー",
    SMSReminder: "SMSリマインダー",
    loginAccount: "ログイン口座",
    phone: "電話",
    phoneNum: "電話番号を入力してください",
    phoneTips: "正しい電話番号を入力してください",
    email: "メール",
    emailNum: "メールアドレスを入力してください",
    emailTips: "正しいメールアドレスを入力してください",
    aears: "地域コードを選択してください",
    passwordError: "正しいパスワードを入力してください",
    passwordTips: "パスワードを入力してください",
    forgetPassword: "パスワードを忘れました",
    noAccount: "アカウントをお持ちでない方",
    goRegister: "今すぐ登録",
    appsys: "アプリでQRコードをスキャンして安全にログイン",
    xzapp: "最新のアプリをダウンロード",
    mmdl: "パスワードでログイン",
    smdl: "QRコードでログイン",
    google: "Google 認証システム",
    nybd: "既に登録済みです",
    zqyzm: "正しい認証コードを入力してください",
    fsyzm: "認証コードを送信",
    flv: "手数料率",
    jz: "純資産",
    jzdesc1:
      "ロング純資産=前回の調整時点の純資産*[1+3*(現物最新取引価格-現物前回調整時点価格)/現物前回調整時点価格*100%]；",
    jzdesc2:
      "ショート純資産=前回の調整時点の純資産*[1-3*(現物最新取引価格-現物前回調整時点価格)/現物前回調整時点価格*100%]；",
    sbd: "3倍ロング",
    sbs: "3倍ショート",
    flvjs:
      'ETFファンディングレートは、プラットフォームが杠杆に対する適切な割合の管理料を日々徴収するもので、基金の運用に関連する費用を支払うためのものです。管理料は純資産の変動に影響を与え、具体的には「相応の杠杆ETFの価値を差し引いた」形で表示されます。また、新加坡時間の0時にのみ徴収されます。該当時間帯に保有していない場合、料金は発生しません。',
    mzsm: "免責事項",
    ido: "私は次を読んで同意します",
    exemption1: "お客様、こんにちは！",
    exemption2:
      "BiKingプラットフォーム（BiKing.ai）の提供するレバレッジETF商品と関連サービス（以下「ETF商品」といいます）にアクセスしていただき、ありがとうございます。ETF商品の説明と以下のリスク警告をよくお読みいただき、お読みになった後に引き続きETF商品をご利用いただく場合、ETF商品のリスクを十分に理解し、ETF商品の使用に関連する損失を負担できる能力があり、かつ、本免責事項の全ての内容に同意したものとみなします。以下のETF商品説明をご覧ください。",
    exemption3: "《レバレッジETF商品FAQ》",
    exemption4: "リスク警告：",
    exemption5:
      "1.購入/売却価格は単位純資産から大きく逸脱しないようにしてください。そうでない場合、相応する損失が発生する可能性があります。",
    exemption6: "2.判断が誤っている場合、極端な市場状況では価格がほぼゼロになるリスクがあります。",
    exemption7:
      "BiKingプラットフォームは、上記のリスクによる損害や責任について一切責任を負わないことをおしらせもうしあげます。本免責事項は、BiKingプラットフォームとお客様との間でのサービスと商品に関する合意のすべてで構成し、他の規約、声明、ルールと一緒に適用されます。",
    bzjs1: "1、“3L”は基本取引ペアの価格が1%上昇した場合、この商品の純資産は3%上昇します",
    bzjs2: "2、“3S”は基本取引ペアの価格が1%下落した場合、この商品の純資産は3%上昇します",
    bzjs3: "3、純資産は通常、毎日0時に調整されます。極端な市場状況では取引中に調整されることがあります。",
    bzjs4: "4、各倍のレバレッジごとに、毎日管理料が発生します",
    bzjs5:
      "5、取引前に純資産を確認してください。この商品は極端な市場状況で価格がゼロに近づく可能性があるため、価格が純資産から大きく逸脱するリスクに注意してください",
    gdjk: "詳細についてはお知らせをご覧ください",
    firstTrading: "初めての取引前に、取引パスワードを設定してください",
    status: "ステータス",
    status1: "マッチング待ち",
    status2: "未約定",
    status3: "ユーザーキャンセル",
    status4: "一部約定",
    status5: "完全約定",
    status6: "無効",
    allCancel: "すべての注文を一括キャンセル",
    canceld: "キャンセル",
    cancelsuccess: "すべての注文がキャンセルされました。[*]件の注文がキャンセルされました",
    VIP1: "VIPランク",
    VIP2: "低手数料、優れた取引体験",
    VIP3: "テイカー（成行注文）：",
    VIP4: "メイカー（指値注文）：",
    buyAmount: "購入数量は",
    sellAmount: "売却数量は",
    buyAmountMin: "購入可能残高が不足しています",
    sellAmountMin: "売却可能残高が不足しています",
  };
  
  
  const common = {
    wan: "万",
    qian: "千",
    yi: "億",
  };
  
  const transferDialog = {
       amountLowTipError: "数量は以下より少なくすることはできません",
     划转: "振替",
    资金互转: "資金間転送",
    币币账户: "現物口座",
    买币账户: "コイン購入口座",
    已冻结: "凍結済み",
    合约账户: "先物口座",
    未开通: "未開通",
    杠杆账户: "レバレッジ口座",
    币贷宝账户: "コインレンディング口座",
    从: "から",
    转至: "へ",
    币种: "通貨",
    数量: "数量",
    全部: "すべて",
    用户未归还借贷的情况下: "ユーザーが未返済の借入金がある場合、リスク率が200％を超える資金は送金できます",
    可划转: "振替可能",
    一阶: "1、第1段階",
    累计净划入: "累積純振替入れ",
    可获得: "取得可能",
    泥码: "泥コード",
    二阶: "2、第2段階",
    您尚未完成实名认证: "本人確認がまだ完了していません",
    余额: "残高",
    立即划转: "即時振替",
    资产划转: "資産振替",
    用于维持现有仓位的保证金: "保有ポジションの維持に使用される証拠金",
    归还数量: "返済数量",
    您的币贷宝账户尚未开通: "コインレンディング口座がまだ開設されていません。先に開設してください",
    请输入正确的数量: "正しい数量を入力してください",
    划转金额不能为: "振替額はゼロにすることはできません",
    账户可用余额不足: "口座の利用可能残高が不足しています",
    划转失败: "振替失敗",
    划转成功: "振替成功",
    本次划转未能获得泥码: "申し訳ありません、泥コードのイベンドは終了しました。今回の振替ではマッドコードを受け取れませんでした",
    您只需再向合约账户划转:"先物口座へ累計[*]以上の USDTを振替すれば、受け取れます。",
    您向合约账户: "先物口座への振替合計累計が [*]USDT以上となると、",
    请输入划转数量: "振替数量を入力してください",
  };
  

  export {
    state,
    subheader,
    purchase,
    purchaseCondition,
    historyProject,
    alipay,
    projectDetails,
    purchaseOver,
    myPurchase,
    mHeader,
    res,
    addContent,
    hyy,
    trading,
    common,
    transferDialog,
  };  


// WEBPACK FOOTER //
// ./src/i18n/lang/ja_JP.js